module.exports = __webpack_public_path__ + "img/bg-login.149de5bd.jpg";